import { toggle, down, up } from 'slide-element';
// Menu Toggle
/**
 * Initializes the main navigation collapse functionality.
 *
 * This function sets up event listeners for the main navigation items and the menu toggle button.
 * It handles the opening and closing of sub-menus and the main menu.
 *
 * @param {HTMLElement} context - The context within which to search for navigation elements.
 */
export function mainNavigationCollapseHelper(context) {
  // Get all the main nav items
  const menuItems = once('navEvent', '.main-nav > li.expanded', context);
  menuItems.forEach(item => {
    item.querySelector('a').addEventListener('click', function (event) {
      if (item.querySelector('.main-nav-sub')) {
        event.preventDefault();

        menuItems.forEach(otherItem => {
          // Remove 'open' class from all other menu items
          if (otherItem !== item) {
            otherItem.classList.remove('open');
          }
        });

        item.classList.toggle('open');
      }
    });
  });

  const btnToggleMenu = once('btnToggleEvent', '#btnToggleMenu', context)[0];
  const header = once('header', '#header', context)[0];

  if (btnToggleMenu) {
    btnToggleMenu.addEventListener('click', function () {
      header.classList.toggle('show-menu');
    });
  }

  context.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      menuItems.forEach(item => {
        item.classList.remove('open');
      });
      header.classList.remove('show-menu');
    }
  });
}

/**
 * Initializes navigation actions for menu items with sub-navigation.
 *
 * @param {HTMLElement} context - The context within which to initialize the navigation actions.
 * @param {Function} once - A function that ensures the initialization happens only once for each matching element.
 */
export function initNavAction(context, once) {
  const levelZMenuItems = once('navAction', '.menu-item--level-0', context);

  levelZMenuItems.forEach(item => {
    const clickTrigger = item.querySelector('.show-hide-subnav');
    const controls = item.querySelector('.menu-item-subnav-wrapper');
    const wrapper = item.querySelector('.link-and-button-wrapper');

    // Make sure elements exist before proceeding
    if (!clickTrigger || !controls) {
      return; // Skip this item if critical elements are missing
    }

    if (wrapper) {
      const link = wrapper.querySelector('.menu-item-link');

      // Make the whole wrapper clickable
      wrapper.addEventListener('click', e => {
        console.log('wrapper clicked');
        // If the user clicks on the button itself, let the original handler work
        if (e.target === clickTrigger || clickTrigger.contains(e.target)) {
          return;
        }

        // Prevent default link behavior
        e.preventDefault();
        e.stopPropagation();

        // Trigger a click on the button
        clickTrigger.click();
      });

      // Prevent the link from navigating when clicked
      if (link) {
        link.addEventListener('click', e => {
          if (item.classList.contains('menu-item--hasSubnav')) {
            e.preventDefault();
          }
        });
      }
    }

    // Original click handler for the button
    clickTrigger.addEventListener('click', e => {
      // Check if we're opening this item
      const isOpening = !item.classList.contains('open');

      // If we're opening this item, close all others first
      if (isOpening) {
        levelZMenuItems.forEach(otherItem => {
          if (otherItem !== item && otherItem.classList.contains('open')) {
            const otherTrigger = otherItem.querySelector('.show-hide-subnav');
            const otherControls = otherItem.querySelector(
              '.menu-item-subnav-wrapper'
            );

            up(otherControls, {
              duration: 300,
              easing: 'ease-in-out'
            });
            otherTrigger.ariaExpanded = 'false';
            otherItem.classList.remove('open');
          }
        });
      }

      toggle(controls, {
        duration: 300,
        easing: 'ease-in-out'
      });
      if (item.classList.contains('open')) {
        clickTrigger.ariaExpanded = 'false';
        item.classList.remove('open');
      } else {
        clickTrigger.ariaExpanded = 'true';
        item.classList.add('open');
      }
    });
  });
}
